<template>
  <div class="hp-wrap" :title="currentPolicy.description">
    <span class="hp-prefix">
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
      HOST POLICY
    </span>
    <span class="hp-pill" :class="currentPolicy.id">
      <span class="hp-pill-icon" :style="{ color: currentPolicy.color }">
        <component :is="iconComponent(currentPolicy.icon)" />
      </span>
      <span class="hp-pill-text">{{ currentPolicy.shortLabel }}</span>
      <span class="hp-pill-deco" aria-hidden="true">
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="4" y1="6" x2="11" y2="6" />
          <line x1="14" y1="6" x2="20" y2="6" />
          <circle cx="12.5" cy="6" r="2" />
          <line x1="4" y1="12" x2="6" y2="12" />
          <line x1="9" y1="12" x2="20" y2="12" />
          <circle cx="7.5" cy="12" r="2" />
          <line x1="4" y1="18" x2="14" y2="18" />
          <line x1="17" y1="18" x2="20" y2="18" />
          <circle cx="15.5" cy="18" r="2" />
        </svg>
      </span>
    </span>
  </div>
</template>

<script>
const ICONS = {
  globe: {
    render(h) {
      return h(
        'svg',
        {
          attrs: {
            width: 16,
            height: 16,
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': 1.8,
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
          },
        },
        [
          h('circle', { attrs: { cx: 12, cy: 12, r: 10 } }),
          h('line', { attrs: { x1: 2, y1: 12, x2: 22, y2: 12 } }),
          h('path', {
            attrs: {
              d: 'M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z',
            },
          }),
        ]
      );
    },
  },
  shield: {
    render(h) {
      return h(
        'svg',
        {
          attrs: {
            width: 16,
            height: 16,
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': 1.8,
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
          },
        },
        [
          h('path', {
            attrs: { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' },
          }),
          h('polyline', { attrs: { points: '9 12 11 14 15 10' } }),
        ]
      );
    },
  },
};

const POLICIES = [
  {
    id: 'public_all',
    shortLabel: 'Public',
    description:
      'Anyone with the link can view post-call analytics, transcripts and recordings.',
    icon: 'globe',
    color: '#4ADE80',
  },
  {
    id: 'private_vc',
    shortLabel: 'VC-gated',
    description:
      'Access restricted to holders of credentials approved by the host.',
    icon: 'shield',
    color: '#A78BFA',
  },
];

export default {
  name: 'HostPolicyPill',
  props: {
    value: { type: String, default: 'public_all' },
  },
  computed: {
    currentPolicy() {
      return POLICIES.find((p) => p.id === this.value) || POLICIES[0];
    },
  },
  methods: {
    iconComponent(name) {
      return ICONS[name] || ICONS.globe;
    },
  },
};
</script>

<style scoped>
.hp-wrap {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  font-family: 'JetBrains Mono', ui-monospace, monospace;
}
.hp-prefix {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  color: rgba(255, 255, 255, 0.55);
  text-transform: uppercase;
}
@media (max-width: 540px) {
  .hp-wrap {
    gap: 8px;
  }
  .hp-prefix {
    display: none;
  }
}
.hp-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: default;
  user-select: none;
}
.hp-pill.private_vc {
  background: rgba(167, 139, 250, 0.08);
  border-color: rgba(167, 139, 250, 0.3);
}
.hp-pill.public_all {
  background: rgba(74, 222, 128, 0.07);
  border-color: rgba(74, 222, 128, 0.3);
}
.hp-pill-icon {
  display: inline-flex;
  align-items: center;
}
.hp-pill-icon >>> svg {
  width: 16px;
  height: 16px;
}
.hp-pill-deco {
  display: inline-flex;
  color: rgba(255, 255, 255, 0.45);
}
</style>
